import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\ProjectCollateralController::store
* @see app/Http/Controllers/Investors/ProjectCollateralController.php:13
* @route '//app.finesthub.de/financing-requests/{project}/collaterals'
*/
export const store = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/financing-requests/{project}/collaterals',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\ProjectCollateralController::store
* @see app/Http/Controllers/Investors/ProjectCollateralController.php:13
* @route '//app.finesthub.de/financing-requests/{project}/collaterals'
*/
store.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return store.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ProjectCollateralController::store
* @see app/Http/Controllers/Investors/ProjectCollateralController.php:13
* @route '//app.finesthub.de/financing-requests/{project}/collaterals'
*/
store.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\ProjectCollateralController::update
* @see app/Http/Controllers/Investors/ProjectCollateralController.php:24
* @route '//app.finesthub.de/financing-requests/{project}/collaterals/{collateral}'
*/
export const update = (args: { project: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [project: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/financing-requests/{project}/collaterals/{collateral}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Investors\ProjectCollateralController::update
* @see app/Http/Controllers/Investors/ProjectCollateralController.php:24
* @route '//app.finesthub.de/financing-requests/{project}/collaterals/{collateral}'
*/
update.url = (args: { project: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [project: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            collateral: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        collateral: typeof args.collateral === 'object'
        ? args.collateral.id
        : args.collateral,
    }

    return update.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{collateral}', parsedArgs.collateral.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ProjectCollateralController::update
* @see app/Http/Controllers/Investors/ProjectCollateralController.php:24
* @route '//app.finesthub.de/financing-requests/{project}/collaterals/{collateral}'
*/
update.put = (args: { project: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [project: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Investors\ProjectCollateralController::update
* @see app/Http/Controllers/Investors/ProjectCollateralController.php:24
* @route '//app.finesthub.de/financing-requests/{project}/collaterals/{collateral}'
*/
update.patch = (args: { project: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [project: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Investors\ProjectCollateralController::destroy
* @see app/Http/Controllers/Investors/ProjectCollateralController.php:33
* @route '//app.finesthub.de/financing-requests/{project}/collaterals/{collateral}'
*/
export const destroy = (args: { project: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [project: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/financing-requests/{project}/collaterals/{collateral}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Investors\ProjectCollateralController::destroy
* @see app/Http/Controllers/Investors/ProjectCollateralController.php:33
* @route '//app.finesthub.de/financing-requests/{project}/collaterals/{collateral}'
*/
destroy.url = (args: { project: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [project: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            collateral: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        collateral: typeof args.collateral === 'object'
        ? args.collateral.id
        : args.collateral,
    }

    return destroy.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{collateral}', parsedArgs.collateral.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ProjectCollateralController::destroy
* @see app/Http/Controllers/Investors/ProjectCollateralController.php:33
* @route '//app.finesthub.de/financing-requests/{project}/collaterals/{collateral}'
*/
destroy.delete = (args: { project: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [project: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const ProjectCollateralController = { store, update, destroy }

export default ProjectCollateralController